import type { HostCapabilities } from "../../capabilities";
import type { MarlinStoreDb } from "../infra/db";
import type { DatarouterConfig, IpJsonContent } from "../types";
import * as ipJson from "../sites/ipJson";
import * as settings from "./store";
import { warn } from "../infra/effects";

export const createSettingsHost = (
  db: MarlinStoreDb,
  capabilities: Pick<HostCapabilities, "files" | "updater" | "syncIntegration">,
) => {
  const { files, updater } = capabilities;
  return {
    saveDatarouterConfig: async (config: DatarouterConfig) => {
      const { changed } = await settings.saveDatarouterConfig(db, config);
      if (changed) {
        await updater
          ?.applyDatarouterConfig(config)
          .catch(warn("datarouter apply"));
        await capabilities
          .syncIntegration?.("config")
          .catch(warn("integration sync"));
      }
      return config;
    },
    saveIpJsonContent: async (content: IpJsonContent) => {
      await settings.saveIpJsonContent(db, content);
      await ipJson.addMachinesFromIpJsonSites(db, content.SITES ?? []);
      await files?.writeIpJson(content).catch(warn("ip.json write"));
    },
    importIpJsonContent: async (content: IpJsonContent) => {
      if (!Array.isArray(content?.SITES))
        throw new Error("No sites found in the selected file");
      await db.transaction("rw", [db.settings, db.machines], async () => {
        await ipJson.replaceSitesFromIpJson(db, content.SITES!);
        await settings.saveIpJsonContent(db, content);
      });
      await files?.writeIpJson(content).catch(warn("ip.json write"));
      await capabilities
        .syncIntegration?.("site")
        .catch(warn("integration sync"));
    },
  };
};
